import { FEE_COMPONENTS } from "../../../../../../../../views/pages/manage/unAssigned/studentCharges/studentChargesDetails/concessionDetails";
import moment from "moment";

const UPDATED_FEE_COMPONENTS = [
    ...FEE_COMPONENTS,
    // { label: "Security fees", value: "SECURITY_FEE", itemTypeVal: "12", feeName: "securityFee" },

]

export const mapFeeBreakupTotals = (studentFeeBreakup, refundApplicationDate) => {
    const totals = {
        totalNetPayable: 0,
        totalPaid: 0,
        firstInstallmentPaid: 0,
        firstInstallmentPayable: 0,
        totalInstallmentsPaidOnOrAfterRefundDate: 0,
        totalPaidRealized: studentFeeBreakup?.totalPaidRealized
    };

    const refundDate = refundApplicationDate ? new Date(refundApplicationDate) : null;

    // initialize totals for each fee component
    UPDATED_FEE_COMPONENTS.forEach(({ feeName }) => {
        totals[`${feeName}TotalNetPayable`] = 0;
        totals[`${feeName}TotalPaid`] = 0;
    });

    const feeSummaryList = studentFeeBreakup?.feeSummaryDTOList || [];

    feeSummaryList.forEach((summary) => {
        summary.feeBreakupDTOList.forEach((breakup) => {
            const itemType = String(breakup.itemType || "");
            if (!itemType) return;

            // extract fee component (last 2 digits) and installment number
            const componentCode = itemType.slice(-2);
            const installmentCode = itemType.length >= 4 ? itemType.slice(-4, -2) : null;

            const matchedFee = UPDATED_FEE_COMPONENTS.find(
                (fee) => fee.itemTypeVal === componentCode
            );

            const netPayable = Number(breakup.netPayable) || 0;
            const paidAmount = Number(breakup.paidAmount) || 0;
            const dueDate = breakup.dueDate ? new Date(breakup.dueDate) : null;

            if (matchedFee) { // considering only regular charges
                totals[`${matchedFee.feeName}TotalNetPayable`] += netPayable;
                totals[`${matchedFee.feeName}TotalPaid`] += paidAmount;

                totals.totalNetPayable += netPayable;
                totals.totalPaid += paidAmount;

                if (installmentCode === "01") {
                    totals.firstInstallmentPaid += paidAmount;
                    totals.firstInstallmentPayable += netPayable;
                }

                if (refundDate && dueDate && dueDate >= refundDate) {
                    totals.totalInstallmentsPaidOnOrAfterRefundDate += paidAmount;
                }
            }
        });
    });

    return totals;
};

const getDurationInDays = (start, end) => {
    if (!start || !end) return null;

    const startDate = moment(start);
    const endDate = moment(end);

    return (endDate.diff(startDate, "days") + 1);
};


export const getCalculatedFeeDetails = (totals, refundDetailsForm, coursePricingDetails) => {
    const {
        totalNetPayable = 0,
        totalPaid = 0,

        regFeeTotalNetPayable = 0,
        adminFeeTotalNetPayable = 0,
        techFeeTotalNetPayable = 0,
        classFeeTotalNetPayable = 0,
        tutionFeeTotalPaid = 0,
        adminFeeTotalPaid = 0,
        techFeeTotalPaid = 0,


        firstInstallmentPaid = 0,
        firstInstallmentPayable = 0,

        totalInstallmentsPaidOnOrAfterRefundDate = 0,

        totalPaidRealized = 0
    } = totals || {};

    const { refundApplicationDate, batchStartDate, batchEndDate } = refundDetailsForm; //batchEndDate is equal to courseEndDate

    const registrationFees = regFeeTotalNetPayable;

    const admissionFees = adminFeeTotalNetPayable;

    const totalInstallmentFeePayable =
        totalNetPayable - registrationFees - admissionFees;

    const totalDurationOfCourse = getDurationInDays(batchStartDate, batchEndDate);

    const usageDuration = getDurationInDays(batchStartDate, refundApplicationDate);

    const firstInstallmentPayableAmount = firstInstallmentPayable;

    const firstInstallmentPaidAmount = firstInstallmentPaid;

    const totalFeePaidExcludingSecurity = totalPaid; // we are considering only regular charges , so security is by default excluded


    const perDayFee = totalDurationOfCourse > 0 ? Number((totalInstallmentFeePayable / totalDurationOfCourse)?.toFixed(2)) : 0;

    const {
        finalAmount = 0,
        firstYearStartDate,
        firstEndDate,
        secondYearStartDate,
        secondEndDate,
        thirdYearStartDate,
        thirdEndDate,
        fourthYearStartDate,
        fourthEndDate,
    } = coursePricingDetails ?? {};

    const totalCourseFee = finalAmount;

    return {
        registrationFees,
        admissionFees,
        totalInstallmentFeePayable,

        totalDurationOfCourse,
        usageDuration,

        firstInstallmentPayableAmount,
        firstInstallmentPaidAmount,

        totalFeePaidExcludingSecurity,
        totalInstallmentsPaidOnOrAfterRefundDate,

        perDayFee,

        totalCourseFee,
        techFee: techFeeTotalNetPayable,
        classroomFee: classFeeTotalNetPayable,
        netFee: totalCourseFee - (registrationFees + admissionFees),
        tuitionFeePaid: tutionFeeTotalPaid,
        totalInstallmentPayable: totalNetPayable - (registrationFees + admissionFees),
        totalInstallmentPaid: totalPaid - (registrationFees + admissionFees),
        totalAmountPaidExcludingPdc: totalPaidRealized,
        admissionTechFeePaid : (adminFeeTotalPaid + techFeeTotalPaid),

        firstYearStartDate,
        firstYearEndDate: firstEndDate,

        secondYearStartDate,
        secondYearEndDate: secondEndDate,

        thirdYearStartDate,
        thirdYearEndDate: thirdEndDate,

        fourthYearStartDate,
        fourthYearEndDate: fourthEndDate,

        refundPercent : 100,

    };
};



